import * as React from 'react'

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { Tooltip } from '@mui/material';

import SearchDialog from '../dialogs/search/SearchDialog';
import Editor from '../../../core/Editor';
import { AssetSearchSource } from '../../../core/EditorConstants';
import SearchTermResultItem from '../../../../api/model/SearchTermResultItem';
import { WithTranslation, withTranslation } from 'react-i18next';

interface Props {
  editor: Editor,
  handleSearchSelection: (searchItem: SearchTermResultItem) => void,
  assetSearchSources: AssetSearchSource[],
  defaultSearch: string,
  isSearchDialogOpen: boolean,
  handleOpenSearchDialog: () => void,
  handleCloseSearchDialog: () => void,
  resetSearch: () => void
}

interface State {
  isDialogOpen: boolean
}

type PropsWithStyles = Props & WithTranslation;

//type PropsWithStyles = Props & WithTranslation & WithStyles<''>

class SearchButton extends React.Component<PropsWithStyles, State>{

  constructor(props: PropsWithStyles) {
    super(props);
    this.state = {
      isDialogOpen: props.isSearchDialogOpen
    }
  }

  handleOpenDialog = () => {
    this.props.handleOpenSearchDialog()
    this.props.resetSearch()
  }

  handleCloseDialog = () => {
    this.props.handleCloseSearchDialog()
  }

  render() {
    const { t } = this.props;

    if (this.props.assetSearchSources.length > 0) {
      return (
        <Box component="span">
          <Tooltip title={t("leftbar.commons.tabs.search")}>
            <IconButton
              cyid={'searchButton'}
              aria-label={t("leftbar.commons.search.placeholder")}
              color="inherit"
              size="small"
              onClick={this.handleOpenDialog}
            >
              <SearchIcon />
            </IconButton>
          </Tooltip>
          <SearchDialog
            editor={this.props.editor}
            handleCloseDialog={this.handleCloseDialog}
            handleSearchSelection={this.props.handleSearchSelection}
            assetSearchSources={this.props.assetSearchSources}
            defaultSearch={this.props.defaultSearch}
            isSearchDialogOpen={this.props.isSearchDialogOpen}
          />
        </Box>
      );
    } else {
      return null;
    }
  }

}

export default withTranslation("leftbar")(SearchButton);

